import { DowngradeModalService } from '@go-modules/services/downgrade-modal/downgrade-modal.service';
import { noop } from 'angular';
import { CloseTypeEnum } from './modal.factory';
import { SelectedService } from 'go-modules/services/selected/selected.service';
import { NgxFeatureFlagService } from '@go-modules/services/feature-flag/feature-flag.service';

export class PostDiscardSessionModalController {
	public $close: (result?: any) => boolean;

	/* @ngInject */
	constructor (
		private ngxDowngradeModalService: DowngradeModalService,
		private $translate: ng.translate.ITranslateService,
		private featureFlag: NgxFeatureFlagService,
		private selectedService: SelectedService
	) {}

	public shouldShowTasks (): boolean {
		const activity = this.selectedService.selected.activity;
		return this.featureFlag.isAvailable('ACTIVITY_TASKS') && activity.show_tasks === true;
	}

	public confirmRestartSession () {
		return this.ngxDowngradeModalService.openConfirmDialog({
			title: this.$translate.instant('modal-confirm-restart-session_title'),
			message: this.$translate.instant('modal-confirm-restart-session_message'),
			confirmText: this.$translate.instant('modal-confirm-restart-session_title')
		}).then(() => {
			return this.$close({ type: CloseTypeEnum.RESTART });
		}).catch(noop);
	}

	public confirmDiscardSession () {
		return this.ngxDowngradeModalService.openConfirmDialog({
			title: this.$translate.instant('modal-confirm-session-discard_confirm-discard'),
			message: this.$translate.instant('modal-confirm-session-discard_sure-discard'),
			confirmText: this.$translate.instant('common_delete')
		}).then(() => {
			return this.$close({ type: CloseTypeEnum.DISCARD });
		}).catch(noop);
	}
}
